import { ChakraStylesConfig } from 'chakra-react-select';

export const BASE_CHAKRA_STYLES: ChakraStylesConfig<any> = {
  option: (provided, state) => {
    return {
      ...provided,
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      bg: state.isSelected
        ? 'blue.600'
        : state.isFocused
        ? 'gray.100'
        : 'transparent !important',
      color: state.isSelected ? 'white' : 'gray.800',
      m: '4px',
      width: 'initial',
      borderRadius: '6px',
      wordBreak: 'break-word',
      '> span': {
        marginRight: 0,
      },
    };
  },
  menuList: (provided) => ({
    ...provided,
    py: 0,
    borderRadius: '8px',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
    overflow: 'initial',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'gray.500',
  }),
  container: (provider) => ({
    ...provider,
    borderColor: 'gray.200',
    '& > div:first-of-type': { background: 'white' },
  }),
  dropdownIndicator: (provided) => ({ ...provided, color: 'gray.600' }),
};
